import { useToast } from "vue-toastification";

const toast = useToast()

export const showSuccessNotification = (message) => {
  toast(message, {
    type: 'success',
    position: 'top-right',
    timeout: 3000
  })
}

export const showFailedNotification = (message) => {
  toast(message || 'Something went wrong', {
    type: 'error',
    position: 'top-right',
    timeout: 3000
  })
}

export const showWarningNotification = (message) => {
  toast(message || 'Something went wrong', {
    type: 'warning',
    position: 'top-right',
    timeout: 3000
  })
}
